import { Tooltip } from 'antd';

import s from './styles.module.scss';
import ButtonLoadingIcon from '../icons/buttonLoadingIcon';

import type { FC, ReactNode } from 'react';

interface IBaseIconButtonProps {
  title?: string;
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  icon: ReactNode;
  className?: string;
  dataCy?: string;
  showTooltip?: boolean;
}

const BaseIconButton: FC<IBaseIconButtonProps> = ({
  icon,
  disabled,
  loading,
  onClick,
  title,
  className,
  dataCy,
  showTooltip = false,
}) => {
  const button = (
    <button
      data-cy={dataCy}
      title={!showTooltip ? title : undefined}
      onClick={onClick}
      disabled={disabled}
      className={className}
    >
      {loading ? (
        <ButtonLoadingIcon className={s['spin-loading-icon']} />
      ) : (
        icon
      )}
    </button>
  );

  if (showTooltip && title) {
    return (
      <Tooltip title={title} placement="bottomLeft">
        {button}
      </Tooltip>
    );
  }

  return button;
};

export default BaseIconButton;
